


















































































import { defineComponent, onMounted, onBeforeUnmount, ref, useContext } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { ProductForProductPageType } from '~/utils/types/solepro/Product';
import { BUNDLE_TYPE_ID, CONFIGURABLE_TYPE_ID, META_PDP_SET_NAME } from '~/utils/constants/product';

import PurchaseOptionCard from '~/components/solepro/ProductPage/PurchaseOptions/PurchaseOptionCard.vue';
import BundlePurchaseOptionCard from '~/components/solepro/ProductPage/PurchaseOptions/BundlePurchaseOptionCard.vue';
import { Pagination, Navigation } from 'swiper'
import { getFirstPriceLabel, getSecondPriceLabel, getAdditionalPriceLabel, getOptionsBlock } from '~/utils/helpers/product';
import ConfigureBundle from './ConfigureBundle.vue';

import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'

// Import Swiper styles
//import 'swiper/swiper-bundle.css'
import { getIsBook } from '~/utils/solepro/products';

SwiperCore.use([Pagination, Navigation])
export default defineComponent({
    props: {
        product: {
            type: Object as PropType<ProductForProductPageType>,
            required: true
        }
    },
    components: {

        PurchaseOptionCard,
        BundlePurchaseOptionCard,
        ConfigureBundle,
        Swiper,
        SwiperSlide
    },
    setup(props) {
        const { product } = props;
        const { app: { i18n }, $fc } = useContext();
        const useCarousel = ref(false);
        const paymentFrequenciesChoosen = ref({});
        const isConfigurable = product.typeId == CONFIGURABLE_TYPE_ID;
        const isMetaPDP = product.attributeSetName == META_PDP_SET_NAME;
        const optionsBlock = ref({})
        const getComponent = (item) => {
            if (item.typeId == CONFIGURABLE_TYPE_ID) {
                if (item.configurable_options.find(el => el.attribute_code != 'tipo_abbonamento')) {
                    optionsBlock.value[item.sku] = getOptionsBlock(item)
                }
                return PurchaseOptionCard

            } else {
                return BundlePurchaseOptionCard

            }
        }
        const options = isMetaPDP ? (product.additionalProducts || []).map(el => {
            const nextItem = product.additionalProducts.find(nxt => nxt.modulesInCartQty && el.modulesInCartQty && nxt.modulesInCartQty.min > el.modulesInCartQty.min)
            return {
                item: el,
                nextItem,
                component: getComponent(el)
            }
        })
            : [{
                item: product,
                nextItem: null,
                component: getComponent(isConfigurable)
            }
            ]
        options.forEach(opt => {
            paymentFrequenciesChoosen.value[opt.item.sku] = opt.item.entryBillingPeriod ?? opt.item.paymentFrequencies[opt.item.paymentFrequencies.length - 1]
        })
        const swiperProps = {
            modules: [Navigation, Pagination],
            slideClass: "slide",
            navigation: {
                prevEl: '.section-purchase-options .navigation-prev',
                nextEl: '.section-purchase-options .navigation-next',
            },
            slidesPerView: 'auto',
            slidesPerGroup: 3,
            direction: "horizontal",
            spaceBetween: 20,
        }
        const handleResize = () => {
            let optionsLength = 0;
            try {
                optionsLength = Object.values(optionsBlock.value).flat().map(el => el['options']).flat().length
            } catch (e) { }
            useCarousel.value = (options.length + optionsLength) > 3 && window.innerWidth >= 1024
        }
        const titleCentered = ref(false)
        onMounted(() => {
            let optionsLength = 0;
            try {
                optionsLength = Object.values(optionsBlock.value).flat().map(el => el['options']).flat().length
            } catch (e) { }
            useCarousel.value = (options.length + optionsLength) > 3 && window.innerWidth >= 1024
            window.addEventListener('resize', handleResize)
            const optL = options.values.length + document.querySelectorAll('.swiper-slide').length
            titleCentered.value = !useCarousel.value && (optL == 1 || optL == 3)
        })
        onBeforeUnmount(() => {
            window.removeEventListener('resize', handleResize)

        })
        const hasOnlyNotBuyable = options.length>0 && options.every(el=>!el.item.buyable)
        return {
            isConfigurable,
            isBundle: product.typeId == BUNDLE_TYPE_ID,
            isMetaPDP,
            options,
            swiperProps,
            useCarousel,
            paymentFrequenciesChoosen,
            i18n,
            optionsBlock,
            isBook: getIsBook(props.product),
            titleCentered,
            hasOnlyNotBuyable
        }
    },
    methods: {
        calculateHeights(swiper) {
            const slides = swiper.$el[0].querySelectorAll('.slide');
            const tallest = Array.from(slides).reduce((tallest: Element, slide: Element) => {
                return slide.querySelector('.solepro-option-card').getBoundingClientRect().height > tallest.querySelector('.solepro-option-card').getBoundingClientRect().height ? slide : tallest;
            });
            const h = (tallest as HTMLElement).offsetHeight + 'px';
            slides.forEach(el => el.querySelector('.solepro-option-card').style.height = h)
        },
        afterInit(swiper) {
            const interval = setInterval(() => {
                //const slides = swiper.$el[0].querySelectorAll('.slide');
                const slides = swiper.slides;
                if (slides.length > 1) {
                    clearInterval(interval);
                    swiper.update();
                    console.log('updated');
                    this.calculateHeights(swiper)
                }
            }, 100)
            setTimeout(() => {
                clearInterval(interval)
            }, 5000)
        },
        getFirstPriceLabelProp(product) {
            return getFirstPriceLabel(product, this.paymentFrequenciesChoosen[product.sku], this.i18n, this.$fc)
        },
        getSecondPriceLabelProp(product) {
            return getSecondPriceLabel(product, this.paymentFrequenciesChoosen[product.sku], this.i18n, this.$fc)
        },
        changeFrequency(product, val) {
            this.paymentFrequenciesChoosen[product.sku] = val;
            this.$forceUpdate()
        }
    }
})
